import { useOrganization } from "@/queries/organization-queries";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

/**
 * Hook that returns true if Ona features should be enabled based on organization tier.
 * Returns true if organization tier is FREE_ONA or CORE.
 */
export const useOnaEnabledForOrg = () => {
    const { data: organization, isLoading: orgLoading } = useOrganization();

    const tierEnabled =
        organization?.tier === OrganizationTier.FREE_ONA || organization?.tier === OrganizationTier.CORE;

    return {
        value: tierEnabled,
        loading: orgLoading,
    };
};
